import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';
import {RoomParty} from '../../../graphql/groups.datatypes';
import {gqlRoomParty} from './getRoomParties.api';

interface RoomPartiesData {
    roomParties: void,
    myRoomParties: void,
    roomPartiesInMyGroup: {
        data: RoomParty[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_ROOM_PARTIES_QUERY = gql`
  query roomPartiesInMyGroup($groupRef: String!, $count: Int!, $page: Int!, $where: WhereConditions, $hasGroupBooking: QueryRoomPartiesInMyGroupHasGroupBookingWhereHasConditions, $orderBy: [OrderByClause!]){
    roomPartiesInMyGroup(groupRef: $groupRef, first: $count, page: $page, where: $where, hasGroupBooking: $hasGroupBooking, orderBy: $orderBy){
      data {
        ${gqlRoomParty}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getRoomPartiesInMyGroup = (groupRef: string, count: number, page: number, where?: any, orderBy?: any, hasGroupBooking?: any) => useQuery<RoomPartiesData>(
    GET_ROOM_PARTIES_QUERY,
    {
        variables: {
            groupRef,
            count,
            page,
            where,
            hasGroupBooking,
            orderBy,
        },
    }
);

export default getRoomPartiesInMyGroup;
